



































import { defineComponent, PropType } from '@vue/composition-api';
import { GroupEngagementData, REPORT_TYPE } from '@front-app/services/CommunityApi/CommunityReportsApi';

type PickEnum<T, K extends T> = {
	[P in keyof K]: P extends K ? P : never;
};

type ENGAGEMENT_REPORT_ITEMS = PickEnum<
	REPORT_TYPE,
	REPORT_TYPE.ACTIVE_MEMBERS
	| REPORT_TYPE.CONTENT_INTERACTIONS
	| REPORT_TYPE.DISCUSSION_TOPICS
	| REPORT_TYPE.DISCUSSION_POSTS
	| REPORT_TYPE.DISCUSSION_VIEWS
	| REPORT_TYPE.FILE_AND_LINK_SHARES
	| REPORT_TYPE.FILE_DOWNLOADS
>;

const REPORT_LABELS: Record<ENGAGEMENT_REPORT_ITEMS, string> = {
	[REPORT_TYPE.ACTIVE_MEMBERS]: 'csr.community-queries.reports.active-members',
	[REPORT_TYPE.CONTENT_INTERACTIONS]: 'csr.community-queries.reports.content-interactions',
	[REPORT_TYPE.DISCUSSION_TOPICS]: 'csr.community-queries.reports.new-discussion-topics',
	[REPORT_TYPE.DISCUSSION_POSTS]: 'csr.community-queries.reports.new-discussion-posts',
	[REPORT_TYPE.DISCUSSION_VIEWS]: 'csr.community-queries.reports.discussion-views',
	[REPORT_TYPE.FILE_AND_LINK_SHARES]: 'csr.community-queries.reports.file-and-link-shares',
	[REPORT_TYPE.FILE_DOWNLOADS]: 'csr.community-queries.reports.shared-file-downloads',
};

export default defineComponent({
	components: {},
	props: {
		reportData: {
			type: Array as PropType<GroupEngagementData[]>,
			required: true,
		},
	},
	setup() {
		return {
			REPORT_LABELS,
		};
	},
});
